import { render, staticRenderFns } from "./SkillNameDetail.vue?vue&type=template&id=3e9f982a&scoped=true&"
import script from "./SkillNameDetail.vue?vue&type=script&lang=js&"
export * from "./SkillNameDetail.vue?vue&type=script&lang=js&"
import style0 from "./SkillNameDetail.vue?vue&type=style&index=0&id=3e9f982a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f982a",
  null
  
)

export default component.exports